import React, { useEffect } from "react";
import styled from "styled-components/macro";
import { DefaultText, shadow } from "theme/GlobalElements";
import { device } from "../../theme/Breakpoints";
import { colors } from "theme/Theme";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchReelProducts,
  selectHighlightedProductsType,
  setHighlightedProductsType,
} from "features/ProductReel/productReelSlice";
import { productReelTypeToText } from "features/ProductReel/utils";
import { isMobileOnly } from "react-device-detect";

interface CategoryReelTabBarProps {}

const CategoryReelTabBar: React.FC<CategoryReelTabBarProps> = () => {
  const dispatch = useDispatch();

  const highlightedProductsType = useSelector(selectHighlightedProductsType);

  useEffect(() => {
    dispatch(fetchReelProducts(highlightedProductsType));
  }, [dispatch, highlightedProductsType]);

  const setActive = (item: string): void => {
    if (productReelTypeToText[highlightedProductsType] === item) {
      return;
    }

    const selectedType = Object.keys(productReelTypeToText).find(
      (key: string) => productReelTypeToText[key] === item
    );

    if (selectedType) {
      dispatch(setHighlightedProductsType(selectedType));
    }
  };

  return (
    <CategoryReelTabBarContainer>
      {Object.values(productReelTypeToText).map((item, idx) => {
        return (
          <Wrapper
            key={idx}
            isActive={item === productReelTypeToText[highlightedProductsType]}
          >
            <Text
              className={isMobileOnly ? "text-xs" : "text-sm"}
              isActive={item === productReelTypeToText[highlightedProductsType]}
              onClick={() => setActive(item)}
            >
              {item}
            </Text>
          </Wrapper>
        );
      })}
    </CategoryReelTabBarContainer>
  );
};

const CategoryReelTabBarContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 12px 16px;
  width: 100%;
  max-width: 1500px;
  overflow-x: auto;

  ::-webkit-scrollbar {
    /* Hide scrollbar for Chrome, Safari and Opera */
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  @media only screen and (${device.tablet}) {
    gap: 12px;
    padding: 20px;
  }
`;
const Wrapper = styled.div<{ isActive: boolean }>`
  box-sizing: border-box;
  flex: 1 0 max-content;
  cursor: pointer;
  min-width: 112px;
  padding: 10px 14px;
  background-color: white;
  border-radius: 8px;
  ${(props) => props.isActive && `${shadow}`};
  transition: box-shadow 180ms ease, transform 180ms ease;
  transform: ${(props) => (props.isActive ? `translateY(-1px)` : `none`)};
  z-index: ${(props) => (props.isActive ? `2` : `1`)};
`;
const Text = styled(DefaultText)<{ isActive: boolean }>`
  text-align: center;
  font-weight: bold;
  color: ${(props) =>
    props.isActive ? `${colors.light_blue}` : `${colors.darkest_gray}`};
`;

export default React.memo(CategoryReelTabBar);
